import React, { useContext, useRef } from 'react';
import { useDropdownMenu } from '@lwt-helix/useDropdownMenu';
import DropdownMenuItem from './DropdownMenuItem.js';
import DropdownMenu from './DropdownMenu.js';
import { NavbarHelixIcon } from './NavbarHelixIcon.js';
import { NavbarContext } from './NavbarContext.js';
import { clickDropdownItem } from './NavbarHelpers.js';

var NavbarHelpDropdownMenu = function NavbarHelpDropdownMenu(_ref) {
  var menuItems = _ref.menuItems,
      dataLwtId = _ref.dataLwtId,
      className = _ref.className,
      linkWrapper = _ref.linkWrapper,
      location = _ref.location,
      _ref$hideHelpHeader = _ref.hideHelpHeader,
      hideHelpHeader = _ref$hideHelpHeader === void 0 ? false : _ref$hideHelpHeader,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '300px' : _ref$maxWidth;

  var _useDropdownMenu = useDropdownMenu({
    placement: 'bottom-end',
    items: menuItems,
    itemToString: function itemToString(item) {
      return item.label ? item.label : '';
    },
    offset: [0, 8],
    resetSelectedItemOnClose: true
  }),
      isOpen = _useDropdownMenu.isOpen,
      getToggleButtonProps = _useDropdownMenu.getToggleButtonProps,
      getMenuProps = _useDropdownMenu.getMenuProps,
      highlightedIndex = _useDropdownMenu.highlightedIndex,
      getItemProps = _useDropdownMenu.getItemProps,
      setReferenceElement = _useDropdownMenu.setReferenceElement,
      setPopperElement = _useDropdownMenu.setPopperElement,
      attributes = _useDropdownMenu.attributes,
      styles = _useDropdownMenu.styles;

  var _useContext = useContext(NavbarContext),
      helpMenuLocation = _useContext.helpMenuLocation;

  var menuRef = useRef(null);

  var isActive = function isActive() {
    return menuItems ? menuItems.filter(function (item) {
      return item.active;
    }).length > 0 || menuItems.filter(function (item) {
      return item.url === helpMenuLocation;
    }).length > 0 : false;
  };

  var handleKeyDown = function handleKeyDown(e) {
    clickDropdownItem(e, menuRef);
  };

  return React.createElement("div", {
    className: "helix-unified-nav__additional-nav-item helix-unified-nav__additional-help-link ".concat(className ? className : ''),
    ref: setReferenceElement,
    "data-lwt-id": dataLwtId
  }, React.createElement("button", Object.assign({}, getToggleButtonProps(), {
    "aria-label": 'Help Menu',
    className: "helix-unified-nav__nav-button helix-unified-nav__nav-button-help ".concat(isActive() ? 'active' : '', " ")
  }), React.createElement(NavbarHelixIcon, {
    iconName: 'question_help'
  })), React.createElement(DropdownMenu, Object.assign({
    inNavbar: true,
    maxWidth: maxWidth,
    ref: setPopperElement,
    isOpen: isOpen,
    style: styles.popper,
    className: 'helix-unified-nav__user-dropdown-menu'
  }, attributes.popper), React.createElement("ul", Object.assign({}, getMenuProps({
    onKeyDown: function onKeyDown(e) {
      return handleKeyDown(e);
    },
    ref: function ref(_ref2) {
      return menuRef.current = _ref2;
    }
  })), isOpen && menuItems.length > 0 && React.createElement(React.Fragment, null, !hideHelpHeader && React.createElement("li", {
    className: 'section-header section-header-bold'
  }, "Help"), menuItems.map(function (item, index) {
    return React.createElement(DropdownMenuItem, {
      menuItem: item,
      index: index,
      linkWrapper: linkWrapper,
      highlightedIndex: highlightedIndex,
      getItemProps: getItemProps,
      className: location && location.pathname === item.url ? 'active' : '',
      key: "".concat(item.label).concat(index)
    });
  })))));
};

export { NavbarHelpDropdownMenu as default };